import { equals } from "ramda";

function getStateWithoutPage(state) {
  const { page, ...rest } = state || {};

  return rest;
}

export function getInMemoryCache() {
  let cachedHits = null;
  let cachedState = null;

  return {
    read({ state }) {
      return equals(cachedState, getStateWithoutPage(state)) ? cachedHits : null;
    },
    write({ state, hits }) {
      cachedState = getStateWithoutPage(state);
      cachedHits = hits;
    },
    invalidate() {
      cachedHits = null;
      cachedState = null;
    },
  };
}
